import {Button} from "../../../basic/button";
import {Badge} from "../../../basic/badge";
import {Card} from "../../../basic/card";
import {Building2, Copy} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {VwpTeam} from "../../../../store/generated/api";
import {formatDate} from "../../../../utils/dateUtils";
import {getTeamDisplayName} from "../../../../utils/teamUtils";
import {toast} from "sonner";

interface TeamInfoProps {
    selectedTeam: VwpTeam;
}

export function TeamInfo({selectedTeam}: TeamInfoProps) {
    const {t} = useTranslationWithKeys();

    const handleCopyTeamId = () => {
        if (selectedTeam.id) {
            navigator.clipboard.writeText(selectedTeam.id);
            toast.success(t('admin.teams.teamManagement.teamIdCopied'));
        }
    };

    return (
        <div className="space-y-4">
            <div className="flex items-center gap-3 pb-4 border-b">
                <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
                    <Building2 className="h-6 w-6 text-primary"/>
                </div>
                <div className="flex-1">
                    <h3>{getTeamDisplayName({
                        teamName: selectedTeam.name,
                        firstName: selectedTeam.adminName?.split(' ')[0],
                        lastName: selectedTeam.adminName?.split(' ').slice(1).join(' ')
                    }) ?? t('common.noTeam')}</h3>
                    <div className="flex items-center gap-2">
                        <p className="text-muted-foreground">{t('admin.teams.teamManagement.teamId')}: {selectedTeam.id}</p>
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={handleCopyTeamId}
                            className="h-5 w-5"
                            title={t('common.copy')}
                        >
                            <Copy className="h-3.5 w-3.5"/>
                        </Button>
                    </div>
                </div>
                <Badge variant={selectedTeam.status === "ACTIVE" ? "default" : "secondary"}>
                    {selectedTeam.status}
                </Badge>
            </div>

            <div className="grid grid-cols-3 gap-4">
                <Card className="p-4">
                    <p className="text-muted-foreground">{t('admin.teams.teamManagement.totalMembers')}</p>
                    <p>{selectedTeam.members}</p>
                </Card>
                <Card className="p-4">
                    <p className="text-muted-foreground">{t('admin.teams.teamManagement.totalLicenses')}</p>
                    <p>{selectedTeam.totalLicenses}</p>
                </Card>
                <Card className="p-4">
                    <p className="text-muted-foreground">{t('admin.teams.teamManagement.created')}</p>
                    <p>{formatDate(selectedTeam.createdDate)}</p>
                </Card>
            </div>
        </div>
    );
}